window.okeReviewsWidgetOnInit = function () {
  setupAggregate();

  const reviewMain = document.querySelector('.js-okeReviews-reviews-main');
  if (reviewMain) {
    const callback = function (mutationList) {
      for (const mutation of mutationList) {
        mutation.addedNodes.forEach(n => setupIndividualReviews(n));
      }
    };
    const observer = new MutationObserver(callback);
    observer.observe(reviewMain, { childList: true });
    // Run callback for the first time
    const reviews = document.querySelectorAll('.okeReviews-reviews-review');
    reviews.forEach(n => setupIndividualReviews(n));
  }
};

function setupAggregate() {
    const reviewsAggregateSide = document.querySelector('.okeReviews-widget-holder .okeReviews-reviewsAggregate-side');
    const reviewsWidgetHolder = document.querySelector('.okeReviews-widget-holder');
    // Move aggregate section above widget navbar
    if (reviewsAggregateSide && reviewsWidgetHolder) {
        reviewsWidgetHolder.insertAdjacentElement('afterbegin', reviewsAggregateSide);
    }
}

function setupIndividualReviews(nodeElement) {
    if (nodeElement) {
    const reviewerProfileDetails = nodeElement.querySelector('.okeReviews-review-reviewer-profile-details');
    const reviewPrimary = nodeElement.querySelector('.okeReviews-review-primary');
    // Move Review Profile Details above Review Star Rating
    if(reviewerProfileDetails && reviewPrimary) {
    reviewPrimary.insertAdjacentElement('afterbegin', reviewerProfileDetails);
    }
  }
}